(function(){
  const popup = document.getElementById('notice-popup');
  const closeBtn = document.getElementById('popup-close');
  const hideTodayCheckbox = document.getElementById('hide-today');

  // ====== 설정 ======
  const startDate = new Date('2026-04-30T17:00:00'); // 노출 시작일
  const endDate   = new Date('2026-05-06T00:00:00'); // 노출 종료일
  // =================

  function isWithinSchedule(){
    const now = new Date();
    return now >= startDate && now <= endDate;
  }

  function getStorageKey(){
    const path = window.location.pathname;
    if (path === "/") {
      return 'popup-hide-today-home'; // 메인 페이지 전용
    } else if (path.includes("/products/")) {
      return 'popup-hide-today-product'; // 상품 상세 전용
    }
    return 'popup-hide-today-other'; // 혹시 다른 경우
  }

  function isHiddenToday(){
    const STORAGE_KEY = getStorageKey();
    const savedDate = localStorage.getItem(STORAGE_KEY);
    const today = new Date().toDateString();
    return savedDate === today;
  }

  function isAllowedPage(){
    const path = window.location.pathname;
    const isHome = path === "/";
    const isProductPage = path.includes("/products/");
    return isHome || isProductPage;
  }

  function showPopup(){
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function hidePopup(){
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function saveHideToday(){
    if(hideTodayCheckbox.checked){
      const STORAGE_KEY = getStorageKey();
      localStorage.setItem(STORAGE_KEY, new Date().toDateString());
    }
  }

  // 초기 실행
  if(isAllowedPage() && isWithinSchedule() && !isHiddenToday()){
    showPopup();
  }

  closeBtn.addEventListener('click', () => {
    saveHideToday();
    hidePopup();
  });

  popup.addEventListener('click', (e) => {
    if(e.target === popup){
      saveHideToday();
      hidePopup();
    }
  });
})();